//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {

    'use strict';

    angular.module('container.widgets')
        .factory('pagingtableColumnTextFilterService', pagingtableColumnTextFilterService);

    function pagingtableColumnTextFilterService($rootScope) {

        let service = {};
        let lastTextSearch;
        let lastSortDirection;;

        service.sorting = (data) => { 
            
            let filterDto = getFilterDto();              
            _.assign(filterDto,  {
                sorting: {
                    "sortField": data.columnKey,
                    "sortOrder": data.column.sortDirection === "desc" ? 1 : 0
                }
            });        
            $rootScope.$emit('filterAppllied', filterDto);                      
            
        };

        service.filter = data => {            
                   
            let filterDto = getFilterDto();
            const filter = {};
            filter[data.columnKey] = data.searchText
            _.assign(filterDto,  filter);
            if (data.column.sortDirection) {
                _.assign(filterDto,  {
                    sorting: {
                        "sortField": data.columnKey,
                        "sortOrder": data.column.sortDirection === "desc" ? 1 : 0
                    }
                });
            }

            let filteredItems = data.unfilteredItems.slice();            

            // Filter by text
            if (data.searchText !== undefined || data.column.sortDirection !== undefined) {
                if (data.searchText !== "" && data.searchText !== undefined) {
                    data.itemsFiltered([]);
                    $rootScope.$emit('filterAppllied', filterDto);
                }
                else if (data.column.sortDirection !== undefined) {
                    data.itemsFiltered(filteredItems); 
                    $rootScope.$emit('filterAppllied', filterDto);
                }
                else {
                    data.itemsFiltered(filteredItems); 
                    $rootScope.$emit('getDefaultPage');    
                }                                
            }            

            // reset filter
            if (lastTextSearch !== undefined && lastTextSearch !== "" && data.searchText === undefined) {
                $rootScope.$emit('getDefaultPage');     
            }

            // reset sort direction
            if (lastSortDirection !== undefined && data.column.sortDirection === undefined) {  
                data.itemsFiltered(filteredItems);             
                $rootScope.$emit('getDefaultPage');     
            }
            
            lastTextSearch = data.searchText;
            lastSortDirection = data.column.sortDirection;                          
            
        };

        function getFilterDto() {
            let filterDto = {                
                paging: {
                    "page": 1,
                    "rows": 200
                }
            }
            return filterDto;
        }                

        return service;
    }
})();